import { Moment } from 'moment';

export interface GroundTruth {
  id: number;
  lastUpdatedAt: Moment;
  payload: GTPayloadV7;
  minimumScore: number;
  surveyId: number;
  version?: number;
}

interface GTPayloadV7 {
  scores: Record<string, number>[][];
  evaluationFormulas: unknown[];
  minimumSectionScores: number[];
  minimumScorePerQuestion: (number|null)[][];
  maximumScorePerQuestion: (number|null)[][];
  unity: (unknown|null)[][][];
  optionalSectionScoring: (number|null)[];
}

export type GroundTruthById = {
  [key: number]: GroundTruth;
}

/** Redux State */
export interface GroundTruthState {
  selectedGroundTruth?: number;
  byId: GroundTruthById;
  allIds: number[];
}

/** Redux constants and Action types */

export const SET_GROUND_TRUTHS = 'SET_GROUND_TRUTHS';
export const SET_SELECTED_GROUND_TRUTH = 'SET_SELECTED_GROUND_TRUTH';
export const UPDATE_GROUND_TRUTH = 'UPDATE_GROUND_TRUTH';
export const ADD_GROUND_TRUTH = 'ADD_GROUND_TRUTH';
export const DELETE_GROUND_TRUTH = 'DELETE_GROUND_TRUTH';

type setGroundTruths = {
  type: typeof SET_GROUND_TRUTHS;
  payload: GroundTruth[];
};

type setSelectedGroundTruth = {
  type: typeof SET_SELECTED_GROUND_TRUTH;
  payload?: number;
}

type updateGroundTruth = {
  type: typeof UPDATE_GROUND_TRUTH;
  payload: GroundTruth;
}

type addGroundTruth = {
  type: typeof ADD_GROUND_TRUTH;
  payload: GroundTruth[];
}

type deleteGroundTruth = {
  type: typeof DELETE_GROUND_TRUTH;
  payload: number;
}

export type GroundTruthActionTypes = setGroundTruths | setSelectedGroundTruth
| updateGroundTruth | addGroundTruth | deleteGroundTruth;
